const no_internet_connexion = {
  title: 'Connexion interompue',
  subtitle: 'Vérifier votre connexion internet et réessayer',
  retry: 'Réessayer',
}

export default no_internet_connexion
